import { Env, Hosts } from './env.type';

export const defaultHosts: Hosts = {
  vsAdminApp: 'https://admin.stage.cloud.viewsonic.com',
  vsApp: 'https://stage.cloud.viewsonic.com',
  vsApi: 'https://api.stage.cloud.viewsonic.com',
  vsSsoApi: 'https://api.stage.viewsonic.cloud',
  vsAsset: 'https://assets.stage.cloud.viewsonic.com',
};

export const env: (opts: { hosts: Hosts }) => Env = ({ hosts }) => ({
  deployEnv: 'stage',
  apiEndpoint: {
    mvb: 'https://api.stage.myviewboard.com',
    vs: hosts.vsApi,
    dmAdmin: 'https://dm.stage.myviewboard.cloud/api/dm/admin',
    vsSubscription: `${hosts.vsApi}/subscription/graphql/v1/subscription`,
    vsAuth: hosts.vsApp,
    vsSso: hosts.vsSsoApi,
    vsAdminAuth: hosts.vsAdminApp,
  },
  oidcAuthority: {
    vs: `${hosts.vsApp}/auth/v1/oidc`,
    vsAdmin: `${hosts.vsAdminApp}/auth/v1/oidc`,
  },
  appUrl: {
    legalDoc: `${hosts.vsApp}/legal`,
    accountPortal: `${hosts.vsApp}/account`,
    entityPortal: `${hosts.vsApp}/entity`,
  },
  applicationInsightsInstrumentationKey: {
    mvb: '216b8495-a1e5-41b7-9e28-954ec64abaf4',
  },
  assets: {
    vs: `${hosts.vsAsset}`,
  },
  product: {
    mvb: 'https://stage.myviewboard.com/preview',
    dm: 'https://stage.myviewboard.com/mydashboard/dm',
    classSwift: 'https://www.classswift.viewsonic.io/',
    teamone: 'https://stage.teamone.viewsonic.com/dashboard',
    originals: 'https://stage.myviewboard.com/originals',
  },
  downloads: {
    nfcConnectorInstaller:
      'https://store2.myviewboard.com/uploads/launcher-nfc/NFC-ConnectorInstaller_1.0.4.exe',
  },
});
